/* corex-textil-cart.js · Fase 3 del personalizador de camisetas: archivos de producción y líneas del carrito.
   Reglas puras (testeadas) + la subida a Cloudinary y el POST a /cart/add.js (run).
   Formato de carrito como el flujo textil actual (corex-textil-personalizacion) y el que reconcilia
   corex-cart-cleanup: prendas con _Ref y _corex_group; DTF con _corex_group y Tipo, cantidad = prendas del grupo. */
(function (global) {
  'use strict';

  var PRINT_DPI = 300;
  var METERS_PER_INCH = 0.0254;
  var UPLOAD_ATTEMPTS = 2; /* 1 reintento por archivo */
  /* PNG de impresión: van a Vercel Blob (corex-kpi-proxy, store corex-textil-impresion), sin el límite de 10 MB de
     Cloudinary. KPI: api/textil-upload (token de subida) y api/textil-archivo (enlace estable de las properties). */
  var KPI_BASE = 'https://corex-kpi-proxy.vercel.app';
  var BLOB_CLIENT_URL = 'https://cdn.jsdelivr.net/npm/@vercel/blob@2.8.0/client/+esm';
  var MAX_PRINT_BYTES = 200 * 1024 * 1024;     /* límite del token de subida: por encima, «demasiado pesado» */
  var MULTIPART_BYTES = 8 * 1024 * 1024;       /* subida por partes a partir de aquí (archivos grandes, reintentos por parte) */
  /* Originales de las capas: van a Cloudinary salvo los de más de este tamaño (límite de 10 MB del plan), que van a Blob. */
  var BLOB_ORIGINAL_BYTES = 9.5 * 1024 * 1024;
  var BLOB_TYPES = { 'image/png': 'png', 'image/jpeg': 'jpg' };
  /* URL pública del store corex-textil-impresion (los originales de «Mis diseños» se enlazan directos y no caducan) */
  var BLOB_PUBLIC_BASE = 'https://ldhherulvie5thde.public.blob.vercel-storage.com/';
  var TOO_HEAVY_MSG = 'Tu diseño es demasiado pesado para procesarlo. Prueba con una imagen más ligera o escríbenos.';
  /* VIEW_LABEL: nombres de las properties ocultas ("_Espalda I1") y de _Medidas; el webhook de pedidos
     (corex-kpi-proxy: lib/print-files-textil.js, lib/textil-hoja.js) los lee, no cambiar sin cambiarlo allí. SHOW_LABEL: lo
     que ve el cliente en el carrito (Personalización, Tipo). VIEW_SLUG: nombre de los archivos (lib/textil-blob.js).
     Pecho izq./dcha.: el delantero de las sudaderas de cremallera completa (dos impresiones independientes). */
  var VIEW_LABEL = { delante: 'Delante', pecho_izq: 'Pecho izq', pecho_der: 'Pecho dcha', espalda: 'Espalda', manga_izq: 'Manga izq.', manga_der: 'Manga dcha.' };
  var SHOW_LABEL = { delante: 'Delante', pecho_izq: 'Pecho izq.', pecho_der: 'Pecho dcha.', espalda: 'Detrás', manga_izq: 'Manga izq.', manga_der: 'Manga dcha.' };
  var VIEW_SLUG = { delante: 'delante', pecho_izq: 'pecho-izq', pecho_der: 'pecho-dcha', espalda: 'espalda', manga_izq: 'manga-izq', manga_der: 'manga-dcha' };
  var VIEW_ORDER = ['delante', 'pecho_izq', 'pecho_der', 'espalda', 'manga_izq', 'manga_der'];
  /* Nombre del pack DTF por tipo y nº de impresiones (como las variantes de "Personalización Textil DTF"). */
  function packName(kind, n) {
    if (kind === 'manga') return n === 2 ? 'Ambas mangas' : 'Manga';
    var base = { '10x10': 'Pequeñas', '30x40': 'Standard', '40x50': 'Grande' }[kind] || kind;
    return base + ' x' + n;
  }

  function fmt(v) { return (Math.round(v * 10) / 10).toFixed(1).replace('.', ','); }
  function fmtShort(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }
  function signed(v) { return (v > 0 ? '+' : v < 0 ? '−' : '') + fmtShort(Math.abs(v)); }
  function slug(s) {
    return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'x';
  }
  function isSleeve(vista) { return vista === 'manga_izq' || vista === 'manga_der'; }

  /* "Delante I1", "Espalda I2", "Manga izq." (labels: VIEW_LABEL o SHOW_LABEL) */
  function printLabel(p, labels) {
    var names = labels && typeof labels === 'object' ? labels : VIEW_LABEL; /* .map(printLabel) pasa el índice */
    if (isSleeve(p.vista)) return names[p.vista];
    var n = String(p.nombre || '').replace(/^\D+/, '') || '1';
    return names[p.vista] + ' I' + n;
  }
  function showLabel(p) { return printLabel(p, SHOW_LABEL); }
  function printIndex(p) { return isSleeve(p.vista) ? 1 : Number(String(p.nombre || '').replace(/^\D+/, '')) || 1; }

  function groupId(now, rand) { return 'textil-' + now + '-' + rand; }
  var publicIds = {
    print: function (g, talla, p) { return g + '_' + slug(talla) + '_' + VIEW_SLUG[p.vista] + '-I' + printIndex(p); },
    preview: function (g, color) { return g + '_' + slug(color) + '_vista-previa'; },
    thumb: function (g) { return g + '_miniatura'; },
    design: function (g) { return g + '_diseno'; },
    original: function (g, k) { return g + '_capa-' + k; }
  };

  /* Impresiones que se producen (con capas y tamaño de cobro), en orden de vista. */
  function producedPrints(impresiones) {
    return (impresiones || []).filter(function (p) { return p.capas > 0 && p.tamano; })
      .sort(function (a, b) { return VIEW_ORDER.indexOf(a.vista) - VIEW_ORDER.indexOf(b.vista) || printIndex(a) - printIndex(b); });
  }

  /* Resumen corto visible: "Delante 28×10 + 9×9 · Detrás 30×40 · Manga izq." (medidas en la talla de referencia). */
  function summary(prints, refRows) {
    var dims = function (p) {
      var r = (refRows || []).filter(function (x) { return x.id === p.id; })[0];
      return r && r.ancho != null ? fmtShort(r.ancho) + '×' + fmtShort(r.alto) : '';
    };
    var parts = [];
    ['delante', 'pecho_izq', 'pecho_der', 'espalda'].forEach(function (v) {
      var list = prints.filter(function (p) { return p.vista === v; }).map(dims).filter(Boolean);
      if (list.length) parts.push(SHOW_LABEL[v] + ' ' + list.join(' + '));
    });
    prints.filter(function (p) { return isSleeve(p.vista); }).forEach(function (p) { parts.push(SHOW_LABEL[p.vista]); });
    return parts.join(' · ');
  }

  /* "_Medidas" de una talla: "Delante I1 28×10,0 a 8 cm del cuello, +12 cm · Manga izq. 6,2×6,2 a 2 cm del bajo".
     rows: [{ id, ancho, alto, distancia, desplazamiento }] de esa talla (tabla de medidas por talla). */
  function medidasText(prints, rows) {
    return prints.map(function (p) {
      var r = rows.filter(function (x) { return x.id === p.id; })[0];
      if (!r || r.ancho == null) return null;
      var where = isSleeve(p.vista)
        ? 'a ' + fmtShort(r.distancia == null ? 2 : r.distancia) + ' cm del bajo'
        : 'a ' + fmtShort(r.distancia) + ' cm del cuello, ' + (r.desplazamiento ? signed(r.desplazamiento) + ' cm' : 'centrada');
      /* ancho en cm enteros (tabla por talla), alto con un decimal */
      return printLabel(p) + ' ' + fmtShort(r.ancho) + '×' + fmt(r.alto) + ' ' + where;
    }).filter(Boolean).join(' · ');
  }

  /* Líneas DTF: una por variante de pack (cantidad = prendas del grupo, como reconcilia corex-cart-cleanup).
     groups: r.groups de CorexTextilOrder.priceOrder ({ kind, items: [{ variantId, n }] }); prints: producedPrints.
     Packs repetidos (misma variante) llevan Tipo distinto para que Shopify no fusione las líneas. */
  function dtfItems(groups, prints, gid, units) {
    var byKind = function (kind) { return prints.filter(function (p) { return (isSleeve(p.vista) ? 'manga' : p.tamano) === kind; }); };
    var out = [];
    groups.forEach(function (g) {
      var queue = byKind(g.kind).map(showLabel), seen = {};
      var totals = g.items.reduce(function (acc, it) { acc[it.variantId] = (acc[it.variantId] || 0) + 1; return acc; }, {});
      g.items.forEach(function (it) {
        var covered = queue.splice(0, it.n);
        seen[it.variantId] = (seen[it.variantId] || 0) + 1;
        var dup = totals[it.variantId] > 1 ? ' (' + seen[it.variantId] + ' de ' + totals[it.variantId] + ')' : '';
        out.push({ id: Number(it.variantId), quantity: units, properties: { '_corex_group': gid, 'Tipo': packName(g.kind, it.n) + dup + ' · ' + covered.join(' + ') } });
      });
    });
    return out;
  }

  /* Líneas de prenda: una por variante (color × talla) con sus archivos de esa talla.
     o: { gid, ref, tallaRef, aprobado, derechos («Aceptado <fecha>»), resumen, lines: [{ variantId, color, talla, qty }], prints, rowsByTalla,
          urls: { print: { 'talla|printId': url }, preview: { color: url }, design } } */
  function garmentItems(o) {
    return o.lines.map(function (l) {
      var props = { 'Personalización': o.resumen, 'Talla de referencia': o.tallaRef, '_corex_group': o.gid };
      if (o.ref) props._Ref = o.ref;
      props['_Vista previa'] = o.urls.preview[l.color];
      props['_Diseño'] = o.urls.design;
      props._Aprobado = o.aprobado;
      if (o.derechos) props._Derechos = o.derechos;
      o.prints.forEach(function (p) { props['_' + printLabel(p)] = o.urls.print[l.talla + '|' + p.id]; });
      props._Medidas = medidasText(o.prints, o.rowsByTalla[l.talla] || []);
      return { id: Number(l.variantId), quantity: l.qty, properties: props };
    });
  }

  /* Consumidor (B2C): cada línea de prenda (color × talla) lleva SUS PROPIAS líneas DTF con su misma cantidad y una
     propiedad _corex_linea común, para que el Cart Transform «corex-b2c-merge» (corex-toptex-sync) las una en un
     paquete consumiendo líneas enteras. dtfFor(q) = dtfItems(…, q). B2B no usa esto: una sola tanda de DTF por grupo. */
  function itemsPorLinea(garments, dtfFor) {
    var out = [];
    garments.forEach(function (g) {
      var linea = String(g.id);
      var props = function (p) { var o = {}; Object.keys(p).forEach(function (k) { o[k] = p[k]; }); o._corex_linea = linea; return o; };
      out.push({ id: g.id, quantity: g.quantity, properties: props(g.properties) });
      dtfFor(g.quantity).forEach(function (d) { out.push({ id: d.id, quantity: d.quantity, properties: props(d.properties) }); });
    });
    return out;
  }

  /* JSON del diseño (carrito y «Mis diseños»): vistas con sus impresiones en cm y las imágenes por URL (srcUrl(src) da
     la URL subida de cada original; las miniaturas no se guardan). o: { d (root.cteGetDesign()), gid, producto: { id,
     titulo, handle }, prenda, zonas, srcUrl, pedido, archivos }. Lo leen el webhook de producción (vistas.*.prints[].
     layers[].src) y la carga de diseños guardados (CorexTextilDisenosModel.itemsFromDoc). */
  function designDoc(o) {
    var d = o.d, views = JSON.parse(JSON.stringify(d.views), function (k, v) { return k === 'thumb' ? undefined : v; });
    Object.keys(views).forEach(function (v) {
      views[v].prints.forEach(function (p) { p.layers.forEach(function (l) { if (l.type === 'image') l.src = o.srcUrl(l.src); }); });
    });
    return {
      version: 1, grupo: o.gid, producto: o.producto, prenda: o.prenda || null, zonas: o.zonas || null, fecha: new Date().toISOString(),
      color: d.color, tallaReferencia: d.tallaReferencia, tallaCobro: d.tallaCobro || d.tallaReferencia, vistas: views,
      impresiones: d.impresiones, medidasPorTalla: d.medidasPorTalla, pedido: o.pedido == null ? null : o.pedido, archivos: o.archivos == null ? null : o.archivos
    };
  }

  /* ---------- PNG con resolución (chunk pHYs, como calcetines) ---------- */
  var CRC_TABLE = (function () {
    var t = new Uint32Array(256);
    for (var n = 0; n < 256; n++) {
      var c = n;
      for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
      t[n] = c >>> 0;
    }
    return t;
  })();
  function crc32(bytes) {
    var c = 0xFFFFFFFF;
    for (var i = 0; i < bytes.length; i++) c = CRC_TABLE[(c ^ bytes[i]) & 0xFF] ^ (c >>> 8);
    return (c ^ 0xFFFFFFFF) >>> 0;
  }
  /* Bytes de un PNG con pHYs = dpi (píxeles por metro, unidad 1) justo tras IHDR; quita un pHYs previo. */
  function pngWithDpi(buffer, dpi) {
    var src = new Uint8Array(buffer), view = new DataView(src.buffer, src.byteOffset, src.byteLength);
    var ppm = Math.round(dpi / METERS_PER_INCH), phys = new Uint8Array(21), pv = new DataView(phys.buffer);
    pv.setUint32(0, 9);
    phys.set([0x70, 0x48, 0x59, 0x73], 4);
    pv.setUint32(8, ppm);
    pv.setUint32(12, ppm);
    phys[16] = 1;
    pv.setUint32(17, crc32(phys.subarray(4, 17)));
    var parts = [src.subarray(0, 8)], offset = 8;
    while (offset < src.length) {
      var len = view.getUint32(offset), end = offset + 12 + len;
      var type = String.fromCharCode(src[offset + 4], src[offset + 5], src[offset + 6], src[offset + 7]);
      if (type !== 'pHYs') parts.push(src.subarray(offset, end));
      if (type === 'IHDR') parts.push(phys);
      offset = end;
    }
    var out = new Uint8Array(parts.reduce(function (s, p) { return s + p.length; }, 0)), pos = 0;
    parts.forEach(function (p) { out.set(p, pos); pos += p.length; });
    return out;
  }
  /* Lee ancho, alto y ppp de un PNG (para comprobar archivos). */
  function pngInfo(bytes) {
    var v = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength), info = { width: v.getUint32(16), height: v.getUint32(20), dpi: null };
    for (var off = 8; off < bytes.length;) {
      var len = v.getUint32(off), type = String.fromCharCode(bytes[off + 4], bytes[off + 5], bytes[off + 6], bytes[off + 7]);
      if (type === 'pHYs' && bytes[off + 16] === 1) info.dpi = Math.round(v.getUint32(off + 8) * METERS_PER_INCH);
      off += 12 + len;
    }
    return info;
  }

  /* ---------- subida y carrito (navegador) ---------- */
  function uploadOnce(cfg, file) {
    var fd = new FormData();
    fd.append('file', file.blob, file.name);
    fd.append('upload_preset', cfg.preset);
    fd.append('public_id', file.publicId);
    fd.append('tags', 'textil,' + file.group);
    var type = file.raw ? 'raw' : 'image';
    return fetch('https://api.cloudinary.com/v1_1/' + cfg.cloud + '/' + type + '/upload', { method: 'POST', body: fd })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || data.error || !data.secure_url) throw new Error((data.error && data.error.message) || 'HTTP ' + res.status);
          return data.secure_url;
        });
      });
  }
  function isSizeError(err) { return /file size too large|too large|maximum is \d+/i.test(String(err && err.message)); }
  function uploadWithRetry(cfg, file) {
    var attempt = function (n) {
      return uploadOnce(cfg, file).catch(function (err) {
        if (isSizeError(err)) throw tooHeavy();
        if (n < UPLOAD_ATTEMPTS) return attempt(n + 1);
        var e = new Error('No se ha podido subir «' + file.label + '» (' + err.message + '). Revisa tu conexión e inténtalo de nuevo; no se ha añadido nada al carrito.');
        e.userFacing = true;
        throw e;
      });
    };
    return attempt(1);
  }
  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (b) { return b ? resolve(b) : reject(new Error('No se ha podido generar la imagen.')); }, type, quality);
    });
  }
  function printPng(canvas) {
    return canvasToBlob(canvas, 'image/png').then(function (b) { return b.arrayBuffer(); })
      .then(function (buf) { return new Blob([pngWithDpi(buf, PRINT_DPI)], { type: 'image/png' }); });
  }

  function tooHeavy() { var e = new Error(TOO_HEAVY_MSG); e.userFacing = true; e.tooHeavy = true; return e; }

  /* Archivo de impresión: PNG del navegador a PRINT_DPI (sin pérdida). Solo por encima de MAX_PRINT_BYTES: «demasiado
     pesado». */
  function printFile(canvas) {
    return printPng(canvas).then(function (png) {
      if (png.size > MAX_PRINT_BYTES) throw tooHeavy();
      return png;
    });
  }
  /* Destinos en Blob (rutas que valida corex-kpi-proxy, lib/textil-blob.js). link: lo que se guarda (property o JSON). */
  function blobPrint(g, talla, p) {
    var file = publicIds.print(g, talla, p) + '.png', ref = g + '/' + file;
    return { pathname: 'textil/pendiente/' + ref, contentType: 'image/png', link: KPI_BASE + '/api/textil-archivo?p=' + ref };
  }
  /* Original de una capa si es demasiado grande para Cloudinary (y PNG o JPG); si no, null (va a Cloudinary).
     scope 'pendiente' (pedido: enlace estable; el webhook lo mueve a textil/<nº>/) o 'disenos' («Mis diseños»: URL directa). */
  function blobOriginal(g, k, blob, scope) {
    var ext = BLOB_TYPES[blob.type];
    if (!ext || blob.size <= BLOB_ORIGINAL_BYTES) return null;
    var file = publicIds.original(g, k) + '.' + ext, ref = g + '/' + file;
    if (scope === 'disenos') return { pathname: 'textil/disenos/' + ref, contentType: blob.type, link: BLOB_PUBLIC_BASE + 'textil/disenos/' + ref };
    return { pathname: 'textil/pendiente/' + ref, contentType: blob.type, link: KPI_BASE + '/api/textil-archivo?p=' + ref };
  }
  var blobClientPromise = null;
  function blobClient() {
    if (!blobClientPromise) {
      blobClientPromise = global.CorexTextilIO.importModule(BLOB_CLIENT_URL).catch(function (e) { blobClientPromise = null; throw e; });
    }
    return blobClientPromise;
  }
  /* Sube un archivo a Blob (1 reintento). Si el primer intento llegó a guardarse, el «ya existe» del reintento cuenta como
     subido. Devuelve target.link. */
  function uploadBlob(file) {
    if (file.blob.size > MAX_PRINT_BYTES) return Promise.reject(tooHeavy());
    return blobClient().then(function (m) {
      var attempt = function (n) {
        return m.upload(file.target.pathname, file.blob, {
          access: 'public', handleUploadUrl: KPI_BASE + '/api/textil-upload', contentType: file.target.contentType, multipart: file.blob.size > MULTIPART_BYTES
        }).catch(function (err) {
          var msg = String(err && err.message);
          if (n > 1 && /already exists/i.test(msg)) return null;
          if (/too large|FileTooLarge/i.test(msg)) throw tooHeavy();
          if (n < UPLOAD_ATTEMPTS) return attempt(n + 1);
          var e = new Error('No se ha podido subir «' + file.label + '» (' + msg + '). Revisa tu conexión e inténtalo de nuevo; no se ha añadido nada al carrito.');
          e.userFacing = true;
          throw e;
        });
      };
      return attempt(1);
    }, function () {
      var e = new Error('No se ha podido preparar la subida de los archivos. Recarga la página e inténtalo de nuevo.');
      e.userFacing = true;
      throw e;
    }).then(function () { return file.target.link; });
  }


  /* Tareas de subida en orden. Cada tarea genera su archivo justo antes de subirlo (no se acumulan lienzos grandes).
     jobs: [{ key, label, publicId, raw?, name, blob? (destino en Vercel Blob: blobPrint), blobIfLarge? (blob) => destino o
     null (originales grandes: blobOriginal), make: (urlsSoFar) =>
     Promise<Blob> }] → Promise<{ key: url }> (para los de Blob, el enlace estable) */
  function uploadAll(cfg, gid, jobs, onProgress) {
    var urls = {}, i = 0;
    var next = function () {
      if (i >= jobs.length) return Promise.resolve(urls);
      var job = jobs[i];
      onProgress(i, jobs.length);
      return Promise.resolve(job.make(urls)).then(function (blob) {
        var ext = (String(blob.type).split('/')[1] || 'bin').replace('jpeg', 'jpg').replace('svg+xml', 'svg');
        var name = /\.\w+$/.test(job.name) ? job.name : job.name + '.' + ext;
        var target = job.blob || (job.blobIfLarge ? job.blobIfLarge(blob) : null);
        if (target) return uploadBlob({ blob: blob, target: target, label: job.label });
        return uploadWithRetry(cfg, { blob: blob, name: name, publicId: job.publicId, raw: !!job.raw, group: gid, label: job.label });
      }).then(function (url) { urls[job.key] = url; i++; return next(); });
    };
    return next().then(function (u) { onProgress(jobs.length, jobs.length); return u; });
  }
  function addToCart(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) {
        if (res.ok) return res.json();
        return res.json().catch(function () { return {}; }).then(function (d) {
          var e = new Error(d.description || d.message || 'No se ha podido añadir al carrito. Inténtalo de nuevo.');
          e.userFacing = true;
          throw e;
        });
      });
  }
  /* Refresco del carrito del tema (mismo patrón que corex-textil-personalizacion y calcetines). */
  function refreshThemeCart() {
    try {
      if (global.ajaxCart && typeof global.ajaxCart.load === 'function') global.ajaxCart.load(false, false, false, true);
      else global.dispatchEvent(new CustomEvent('listCart'));
    } catch (e) { /* el contador se actualiza igualmente abajo */ }
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) { document.querySelectorAll('#cart-count').forEach(function (el) { el.textContent = cart.item_count; }); })
      .catch(function () { /* añadido correcto aunque no se refresque el contador */ });
  }

  var api = {
    PRINT_DPI: PRINT_DPI, VIEW_LABEL: VIEW_LABEL, slug: slug, packName: packName, printLabel: printLabel, groupId: groupId, designDoc: designDoc,
    publicIds: publicIds, producedPrints: producedPrints, itemsPorLinea: itemsPorLinea, summary: summary, medidasText: medidasText,
    dtfItems: dtfItems, garmentItems: garmentItems, pngWithDpi: pngWithDpi, pngInfo: pngInfo, crc32: crc32,
    printPng: printPng, printFile: printFile, blobPrint: blobPrint, blobOriginal: blobOriginal, BLOB_PUBLIC_BASE: BLOB_PUBLIC_BASE, MAX_PRINT_BYTES: MAX_PRINT_BYTES, TOO_HEAVY_MSG: TOO_HEAVY_MSG,
    isSizeError: isSizeError, canvasToBlob: canvasToBlob, uploadAll: uploadAll, addToCart: addToCart, refreshThemeCart: refreshThemeCart
  };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.CorexTextilCart = api;
})(this);
